import { atom, selector } from 'recoil';
import { SchemaCatalogResponse } from '../../API';

export const withSchemaCatalog = atom<SchemaCatalogResponse[] | undefined>({
  key: 'config.schemaCatalog',
  default: undefined
});

export const withSchemaCatalogById = selector<(id: string) => SchemaCatalogResponse | undefined>({
  key: 'config.schemaCatalogById',
  get: ({ get }) => {
    const schemas = get(withSchemaCatalog);
    return (id: string) => schemas?.find((s) => s.id === id);
  }
});
